import { type VisibilityContextFieldsetProps } from './VisibilityContextFieldset.types';

/**
 * One viewer context's row of a visibility grid: a fieldset naming the context,
 * two columns inside it, and a footer for what the choices add up to.
 *
 * Extracted rather than copied so the per-question matrix and the section-wide
 * defaults dialog cannot drift apart — the eight hand-rolled callouts P10.6d had
 * to retire were eight copies of a shape nobody owned.
 *
 * Stacks to one column below `md`, where two columns of wrapping text would each
 * be narrower than their longest word.
 */
export function VisibilityContextFieldset({
  legend,
  decision,
  start,
  footer,
}: VisibilityContextFieldsetProps) {
  return (
    <fieldset className="flex flex-col gap-md rounded-md border border-border p-md">
      <legend className="px-sm text-label font-medium text-foreground">{legend}</legend>

      <div className="grid grid-cols-1 gap-md md:grid-cols-2 md:items-start">
        {decision}
        {start}
      </div>

      {footer}
    </fieldset>
  );
}
